import { searchNav } from '/app/app/assets/js/mixins/search_nav.js'

const COMPANY_TYPE_SELECT = "select[name='address[company_type_id]']"
const LOOKUP_FRAME_ID = 'address_lookup'
const COMPANY_TYPE_FRAME_ID = 'address_company_type_field'

const LOOKUP_BASE = '/my/address_lookups'
const COMPANY_TYPE_BASE = '/my/addresses/company_type_field'

const CLEARABLE_FIELD_IDS = [
  'address_name',
  'address_vat_number',
  'address_company_number',
  'address_company_type_other',
  'address_peppol_id',
  'address_phone',
  'address_phone_mobile',
  'address_street_name',
  'address_additional_line',
  'address_house_number',
  'address_box_number',
  'address_zipcode',
  'address_place',
  'address_country_code',
  'address_verification_token',
]

export default ({
  isCompany = false,
  country = '',
  companyTypeId = '',
  companyTypeOther = '',
  selectedIsOther = false,
  view = 'lookup',
  clearConfirm = '',
} = {}) => ({
  ...searchNav(),
  isCompany,
  country,
  companyTypeId: companyTypeId === null ? '' : String(companyTypeId),
  companyTypeOther,
  selectedIsOther,
  view,
  clearConfirm,
  lookupQuery: '',
  pendingCompanyTypeId: null,

  init() {
    this.$watch('companyTypeId', () => this.refreshSelectedIsOther())
    this.$watch('isCompany', () => this.broadcastReadiness())
    this.$watch('view', () => this.broadcastReadiness())
    window.addEventListener('address-lookup:picked', (event) => {
      this.onLookupPicked(event.detail)
    })
    document.addEventListener('turbo:frame-load', (event) => {
      if (event.target.id === COMPANY_TYPE_FRAME_ID) {
        this.applyPendingCompanyType()
      }
    })
    this.$nextTick(() => this.broadcastReadiness())
  },

  broadcastReadiness() {
    this.$dispatch('address-fields:change', {
      ready: this.view === 'editing',
      is_company: this.isCompany,
    })
  },

  onLookupPicked(detail) {
    this.isCompany = !!(detail.company_number || detail.vat_number)
    this.pendingCompanyTypeId = detail.company_type_id ?? null
    this.companyTypeOther = detail.company_type_other ?? ''

    if (detail.country_code) {
      this.country = detail.country_code.toUpperCase()
      this.refreshCompanyTypes()
    } else {
      this.applyPendingCompanyType()
    }
    this.view = 'editing'
  },

  refreshCompanyTypes() {
    this.companyTypeId = ''
    this.loadFrame(COMPANY_TYPE_FRAME_ID, COMPANY_TYPE_BASE, {
      'address[country_code]': this.country,
    })
  },

  applyPendingCompanyType() {
    if (this.pendingCompanyTypeId == null) return

    this.companyTypeId = String(this.pendingCompanyTypeId)
    this.pendingCompanyTypeId = null
  },

  refreshSelectedIsOther() {
    const select = document.querySelector(COMPANY_TYPE_SELECT)
    const option = select?.options[select.selectedIndex]
    this.selectedIsOther = option?.dataset.other === 'true'
  },

  refreshLookup(query) {
    this.view = 'lookup'
    this.lookupQuery = query || ''
    this.loadFrame(LOOKUP_FRAME_ID, LOOKUP_BASE, {
      query: this.lookupQuery,
    })
    this.$nextTick(() => this.$refs.lookupInput?.focus())
  },

  clearForm() {
    if (this.clearConfirm && !confirm(this.clearConfirm)) return

    this.country = ''
    this.companyTypeId = ''
    this.companyTypeOther = ''
    this.pendingCompanyTypeId = null
    this.isCompany = false

    CLEARABLE_FIELD_IDS.forEach((id) => {
      const input = document.getElementById(id)
      if (!input) return
      if (input.tagName === 'SELECT') input.selectedIndex = 0
      else input.value = ''
    })

    this.view = 'editing'
  },

  loadFrame(frameId, basePath, params) {
    const frame = document.getElementById(frameId)
    if (!frame) return

    const url = new URL(basePath, window.location.origin)
    Object.entries(params).forEach(([key, value]) => {
      if (value) url.searchParams.set(key, value)
    })
    frame.src = url.toString()
  },
})
